import React from 'react';
import { Card } from 'primereact/card';

import '../styles/pages.css';

export type SimplePageProps = {
  title: string;
  subtitle: string;
};

export default function SimplePage({ title, subtitle }: SimplePageProps) {
  return (
    <div className="page">
      <div className="page__header">
        <div>
          <h1 className="page__title">{title}</h1>
          <p className="page__subtitle">{subtitle}</p>
        </div>
      </div>

      <Card className="page__card page__cardFull" title={title}>
        <p className="page__muted">Coming Soon.....</p>
      </Card>
    </div>
  );
}
